import React from 'react'
import { FlexDiv } from '../../elements/NumberInput/NumberInputStyles'
import ActionButton from '../components/operationButton/OperationButton'
import { SFXS } from '@orbitalgaming/games-frontend-library'

interface Settings_button_props {
  autoRoll: boolean
  handleAbove: (s: string) => void
  handleAutoConfigs: (b: boolean) => void
  handleManual: () => void
  audio: any
  setAutoRoll: any
  resetAuto: any
}

export default function SettingsButtons({
  autoRoll,
  handleManual,
  handleAutoConfigs,
  handleAbove,
  audio,
  setAutoRoll,
  resetAuto,
}: Settings_button_props) {
  return (
    <>
      <FlexDiv marginTop='5px' marginBottom='15px'>
        {autoRoll && (
          <ActionButton
            width='94px'
            text='BACK TO MANUAL'
            func={() => {
              !audio.isSoundOff && SFXS.goBackSFX.play(), handleManual()
            }}
          />
        )}
        <ActionButton
          text='AUTOROLL'
          func={() => {
            !audio.isSoundOff && SFXS.goForwardSFX.play(),
              handleAutoConfigs(true),
              setAutoRoll(false),
              resetAuto()
          }}
          width={autoRoll ? '94px' : '148.5px'}
        />
        <ActionButton
          text='SETTINGS'
          width={autoRoll ? '94px' : '148.5px'}
          func={() => {
            !audio.isSoundOff && SFXS.goForwardSFX.play(),
              handleAbove('settings')
          }}
        />
      </FlexDiv>
    </>
  )
}
